// getQuoteData
import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Collapsible from './Collapsible';

const QUOTE_COLLAPSE_LENGTH = 75;

export default function CollapsibleTypography(props: any) {
    const quouteCollapseLength =
        props?.quouteCollapseLength || QUOTE_COLLAPSE_LENGTH;
    const incomingQuote = props?.quote;
    const renderDecoration = props?.quoteDecoration;
    const incomingFontStyle = props?.isItalic ? 'italic' : 'normal';
    const theme = useTheme();
    let renderableQuoteCache = incomingQuote;
    let quoteSize = renderableQuoteCache ? renderableQuoteCache?.length : 0;


    try {
        renderableQuoteCache = incomingQuote;
        quoteSize = renderableQuoteCache?.length;
    } catch (e) {

    }
    
    const coreTypography = !props?.isAnalysis ? (
      <Typography component="span" display="inline" sx={{ fontStyle: incomingFontStyle }}>
        {`${renderDecoration}${renderableQuoteCache}${renderDecoration}`}
      </Typography>
    ) : (
      renderableQuoteCache
    );

    const coreTypographyExpend = !props?.isAnalysis
      ? `${renderDecoration}${renderableQuoteCache?.slice(
          0,
          quouteCollapseLength
        )}${renderDecoration}`
      : renderableQuoteCache?.slice(0, quouteCollapseLength)
    if (quoteSize < quouteCollapseLength) {
        return <Stack>
            {coreTypography}
        </Stack>
    }
    else {
        return (
        <Collapsible>
             {({ isExpanded, setIsExpanded }) => (
            <Box
                sx={{
                    color: "inherit",
                }}
            >
                {isExpanded ? (
                    <Typography
                         sx={props?.isAnalysis ? {...props?.style}:{ fontSize:"inherit"}}>
                        {coreTypography}
                        <span
                         onClick = {(event)=>{
                           event.stopPropagation();
                           setIsExpanded(!isExpanded);
                         }}
                         style={{ color: theme?.custom?.mainButtonHighlight, cursor: 'pointer',marginLeft:"10px" }}>Read Less</span>
                    </Typography>
                    
                ) : (
                    <Typography
                        sx={props?.isAnalysis ? {...props?.style}:{ fontStyle: incomingFontStyle }}>
                        {coreTypographyExpend}
                         <span
                          onClick = {(e)=>{
                            e.stopPropagation();
                            // if(props.isInsightTable){
                            //   props?.onClick();
                            // }
                            setIsExpanded(!isExpanded);
                        }}
                         style={{ color: theme?.custom?.mainButtonHighlight, cursor: 'pointer' }}> ...Read More</span>
                    </Typography>
                )}
            </Box>
             )}
        </Collapsible>
        );
    }
}
CollapsibleTypography.defaultProps = {
  quote: '',
  quouteCollapseLength: QUOTE_COLLAPSE_LENGTH,
  quoteDecoration: '',
  fontStyle: 'italic',
  isAnalysis: false,
  isInsightTable: false,
  selected: false,
  onClick: () => {},
  style: {},
};